export default __webpack_public_path__ + "static/media/MapIconJobDetail.42837bbd.svg";